import React from 'react';
import {Row, Col} from 'react-bootstrap';

const Skill = ({title, level}) => {
    const styled = {
        width: level + "%"  
    }
    const gauge = level !== null ? 
        (<div className="cv__skill-gauge-bar">
            <div style={styled}></div>
        </div>) : ""

    return (
        <div className="cv__skill">
            <Row className='align-items-center'>
                <Col   xs={12} sm={12} md={5} xl={5}>
                    <span className='fw-bold font-monospace'>{title}</span> 
                </Col>
                <Col  xs={12} sm={12} md={7} xl={7}>
                    {gauge}
                </Col>
            </Row>
        </div>
    )
}
export default Skill;